import React from 'react'

const StudentData = 
[
    {
        'name': 'John Gilbert',
        'grade': '2nd',
        'id': 563,
        'teacher': 'Mx. Night'
    }
]

export default StudentData